import React from 'react'
import { SVGIconProps } from '../types'
const SvgSkipNext = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="m6 18 8.5-6L6 6zM16 6v12h2V6z" />
  </svg>
)
export default SvgSkipNext
